import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { OfertasEndpointService } from '../ofertas-financieras/services/ofertas-endpoint.service';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { Store } from '@ngrx/store';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';
import { selectSelectedOrganization } from 'src/app/state/selectors/selectedOrganization.selectors';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-empresa',
  templateUrl: './landing-empresa.component.html',
  styleUrls: ['./landing-empresa.component.scss']
})
export class LandingEmpresaComponent implements OnInit {

  public completion: number = 50;
  public offerCount: number = 0;

  public userInfo: IUserInfoCognito | null = null
  private _userInfo$ = this._store.select(selectUserInfo);

  public selectedOrganization: string | null = null
  private _selectedOrganization$ = this._store.select(selectSelectedOrganization);

  public hasSelected = false;

  public isLoading = false;

  constructor(
    public dialog: MatDialog,
    private _apiService: OfertasEndpointService,
    private _store: Store,
    private toastr: ToastrService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    //Validar credenciales para chequear perfil completo
    //Validar ofertas seleccionadas para chequear perfil completo
    this.isLoading = true;
    this._selectedOrganization$.subscribe((selectedOrganization) => {
      this.selectedOrganization = selectedOrganization;
    })

    this._userInfo$.subscribe((userInfo) => {
      this.userInfo = userInfo;
    })
    this._apiService.getVerticalList(this.userInfo, this.selectedOrganization).subscribe(
    (offerTypes) => {
        this.isLoading = false;
        offerTypes.verticalesFinancieras.forEach((vertical: any) => {
          if(vertical.selected == "true") {
            this.hasSelected = true;
            this.completion = 100;
          }
        });
        if(this.completion == 100) {
          this._apiService.getOfferCount(this.userInfo, this.selectedOrganization).subscribe((response: any) => {
            this.offerCount = response.count;
          })
        }
    },
    (error) => {
      this.toastr.error('', 'Error al intentar buscar los datos de la empresa, vuelva a intentarlo mas tarde');
      this.router.navigate([''])
      this.isLoading = false; 
    })
  }

  onDropCredentials(){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
          title: '¿Estás seguro?',
          message: `Si dejas de compartir tus credenciales, ya no podrás consultar nuestros módulos.`,
          textBoton: ['Ok', 'Cancelar'],
      }
    });

    dialogRef.afterClosed().subscribe((hasConfirmed) => {
      if(hasConfirmed) {
        //Llamar a API
      }
    });
  }

}
